import {
  PBSA_ES_PROVIDER_IDS,
  isResidenciasSearchPath,
} from '../../../shared/residenciasSeo.cjs';

export function isResidenciasHubRoute(path) {
  return isResidenciasSearchPath(path);
}

/** Aplica filtro PBSA (sin forStudents) en rutas /residencias */
export function applyPbsaFiltersIfResidencias(path, filters) {
  if (!isResidenciasSearchPath(path)) return false;
  filters.forStudents = false;
  filters.providers = [...PBSA_ES_PROVIDER_IDS];
  return true;
}

export { PBSA_ES_PROVIDER_IDS, isResidenciasSearchPath };
